import styled from 'styled-components';

import { neutralTrans } from 'enable-ui';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px 12px 12px 0px;
  div:nth-child(2) {
    padding: 0px;
  }
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${neutralTrans['neutralTrans-10']};
  margin-bottom: 12px;
`;
